import { Checkbox as MuiCheckbox } from '@material-ui/core';
import { CheckboxProps } from '@material-ui/core/Checkbox/Checkbox';
import {
  CheckBox as Checked,
  CheckBoxOutlineBlank as Unchecked,
  IndeterminateCheckBox,
} from '@material-ui/icons';
import React, { FunctionComponent } from 'react';

export const Checkbox: FunctionComponent<
  Omit<CheckboxProps, 'icon' | 'checkedIcon' | 'indeterminateIcon'>
> = (props) => (
  <MuiCheckbox
    icon={<Unchecked style={{ fontSize: 24 }} />}
    checkedIcon={<Checked style={{ fontSize: 24 }} />}
    indeterminateIcon={<IndeterminateCheckBox style={{ fontSize: 24 }} />}
    {...props}
  />
);
